<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="as-Menu as-Center">
				<!--Default Duration-->
				<div class="as-MenuRow">
					<label class="control-label" style="margin-right: 10px">School</label>
					<div>
						<!-- <select class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="suspensionData.SchoolID">
                            <option value="" style="display:none;"></option>
                            <option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">[{{o.SchoolNumber}}] - {{o.SchoolName}}</option>
                        </select> -->

						<caass-schoolselector [ShowAll]="false" [Disabled]="loading"> </caass-schoolselector>
					</div>
				</div>

				<div class="as-MenuRow">
					<label class="as-Item as-Label">Select Default Suspension Duration (Number of Days):</label>

					<select [disabled]="loading" class="as-Item" name="DefaultDuration" [(ngModel)]="suspensionData.DefaultDuration">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of durationList" [ngValue]="o.Duration">
							{{ o.Duration }}
						</option>
					</select>

					<input [disabled]="loading" class="as-Item" id="Indefinite" name="Indefinite" type="checkbox" [(ngModel)]="suspensionData.Indefinite" />

					<label class="as-Item as-Label" for="Indefinite">Indefinite</label>
				</div>
				<!--Class cuts for suspension-->
				<div class="as-MenuRow">
					<label class="as-Item as-Label">Number of Class Cuts for Suspension</label>

					<select [disabled]="loading" class="as-Item" name="ClassCuts" [(ngModel)]="suspensionData.ClassCuts">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of cutsList" [ngValue]="o.ClassCuts">
							{{ o.ClassCuts }}
						</option>
					</select>

					<label class="as-HelpText as-Item as-Label">0 Disables Feature</label>
				</div>
				<!--Don't count cuts priort to date-->
				<!--Doesn't seem to be supported in 9.5, the USP is all commented out, 
                    and it used to update a field in Infraction that is no longer used-->
				<!--<div class="as-MenuRow">-->
				<!-- <label class="as-Item as-Label">Don't Count Cuts Toward Suspension Prior to:</label> -->

				<!-- <p-calendar class="as-Item" showIcon=true showButtonBar="true" [(ngModel)]="suspensionData.BeforeDate" name="txtBeforeDate"></p-calendar>                     -->

				<!-- <input class="btn btn-default as-Item" type="button" value="Set" (click)="resetIncidents()"> -->

				<!-- <label class="as-HelpText as-Item as-Label">Set may take some time depending upon the number of incidents.</label> -->
				<!-- </div> -->
				<!--Start suspensions after x days-->
				<div class="as-MenuRow">
					<label class="as-Item as-Label">Start Suspensions after X Number of Days (0=Starts Today, 1=Tomorrow, etc):</label>

					<select [disabled]="loading" class="as-Item" name="StartAfterDays" [(ngModel)]="suspensionData.StartAfterDays">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of startAfterList" [ngValue]="o.StartAfterDays">
							{{ o.StartAfterDays }}
						</option>
					</select>
				</div>
				<!--Enable class roster updates-->
				<div class="as-MenuRow">
					<label class="as-Item as-Label" for="RosterUpdate">Enable Class Roster Updates for In-House Suspensions:</label>

					<input
						[disabled]="loading"
						class="as-Item"
						id="RosterUpdate"
						name="RosterUpdate"
						[(ngModel)]="suspensionData.RosterUpdate"
						type="checkbox"
					/>
				</div>
			</div>
			<!--Buttons-->
			<div class="as-Buttons">
				<!--Update Button-->
				<input [disabled]="loading" class="btn btn-primary" type="button" value="Update" (click)="updateSuspensionSettings()" />
			</div>
			<!--Error Message-->
			<div class="form-group">
				<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
					{{ errorMessage }}
				</div>
			</div>
		</div>
	</div>
</div>
